import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import AnimusHeroChrome from "../components/AnimusHeroChrome";
import PageBlocks, { BlockButtons } from "../components/PageBlocks";
import { apiGet } from "../api/client";
import { splitHeadingLastWord } from "../utils/splitHeading";
import "../styles.css";

export default function About() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet('/pages/about')
      .then(setPage)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const c = page?.content || {};
  const seo = page?.seo || {};

  if (loading) {
    return (
      <>
        <Navbar />
        <main className="container" style={{ padding: '4rem 0' }}>
          <div className="video-loading"><div className="spinner"></div></div>
        </main>
        <Footer />
      </>
    );
  }

  const storyHeading = splitHeadingLastWord(c.storyHeading, "My ", "Story");
  const skillsHeading = splitHeadingLastWord(c.skillsHeading, "Technical ", "Skills");

  return (
    <>
      <SEO
        title={page?.title || "About ZeMaxi"}
        description={seo.description || "Learn about ZeMaxi"}
        keywords={seo.keywords || ""}
        url={seo.url || "https://zemaxi.com/about"}
      />
      <Navbar />
      <main>
        <section className="about-hero animus-hero animus-hero-bg">
          <AnimusHeroChrome />
          <div className="container">
            <p className="animus-hero-id font-mono">{'// SECTION_ABOUT'}</p>
            <h1>About <span className="highlight">Zemaxi</span></h1>
            <p>{c.heroSubtitle || ''}</p>
          </div>
        </section>
        <section className="about-section page-body-section">
          <div className="container">
            <div className="about-content">
              <div className="about-bio">
                <aside className="about-profile">
                  <div className="about-image">
                    <img src={c.profileImage || '/images/zemaxi-profile.jpg'} alt={c.profileName || "Zemaxi"} />
                  </div>
                  <div className="about-profile__meta">
                    <strong className="about-profile__name">{c.profileName || "ZeMaxi"}</strong>
                    {c.profileTagline && <span className="about-profile__tagline font-mono">{c.profileTagline}</span>}
                  </div>
                  <BlockButtons buttons={c.profileButtons} />
                </aside>
                <div className="about-text">
                  <h2>{storyHeading.before}<span className="highlight">{storyHeading.highlight}</span></h2>
                  {(c.storyParagraphs || []).map((p, i) => (
                    <p key={i}>{p}</p>
                  ))}
                </div>
              </div>
              {(c.skills || []).length > 0 && (
                <div className="skills">
                  <h2>{skillsHeading.before}<span className="highlight">{skillsHeading.highlight}</span></h2>
                  {c.skillsIntro && <p>{c.skillsIntro}</p>}
                  <div className="skill-list">
                    {(c.skills || []).map((skill, i) => (
                      <div className="skill-tag" key={i}>
                        <i className={skill.icon}></i> {skill.label}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <PageBlocks blocks={c.blocks} />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
